import { render } from "./UsadosPageContent.vue?vue&type=template&id=10e26274"
import script from "./UsadosPageContent.vue?vue&type=script&lang=js"
export * from "./UsadosPageContent.vue?vue&type=script&lang=js"

import "./UsadosPageContent.vue?vue&type=style&index=0&id=10e26274&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__